import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    Form,
    TabContent,
    NavLink,
    NavItem,
    Nav,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal"
import '../../components/Common/Common.css';
import classnames from "classnames"

import {
    getBackupInfoList,
    getDbCapacityInfoList,
    getHagueCrawlInfoList,
    getMadridCrawlInfoList,
    getMadridDiscrepencyInfoList,
    getMadridPdfErrorInfoList,
    getPctCrawlInfoList,
    getRemainingInfoList,
    getServersInfoList,
    getEmailServerInfoList,
    setAdmDataManagementError,
    setAdmDataManagementLoading,
    setAdmDataManagementSuccess
} from "../../store/actions";
import DbCapacityInfo from './DbCapacityInfo';
import BackupInfo from './BackupInfo';
import MadridCrawlInfo from './MadridCrawlInfo';
import HagueCrawlInfo from './HagueCrawlInfo';
import PctCrawlInfo from './PctCrawlInfo';
import MadridPdfErrorInfo from './MadridPdfErrorInfo';
import MadridDiscrepencyInfo from './MadridDiscrepencyInfo';
import ServersCheckInfo from './ServerChkInfo';
import EmailServerStatusInfo from './EmailServerStatusInfo';
import RomarianDbInfo from './RomarianDbInfo';

const DB = "Database";
const MADRID = "Madrid";
const HAGUE = "Hague";
const PCT = "PCT";
const MADRID_PDF_ERROR = "Error";
const SERVERS = "Servers";
const EMAIL_SERVER = "Email server";
const BACKUP = "Backup";
const DISCREPENCY = "Discrepency";
const ROMARIAN = "Romarian DB";

const AdmDataManagement = props => {
    const dispatch = useDispatch();

    // Form open toggle
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const tabItems = [MADRID, HAGUE, PCT, MADRID_PDF_ERROR, SERVERS, EMAIL_SERVER, DB, BACKUP, DISCREPENCY, ROMARIAN];

    const [activeTab, setActiveTab] = useState(MADRID);
    const toggleActiveTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    const { loading, error, success, result, dbCurrentUsage } = useSelector(state => ({
        loading: state.admDataManagement.loading,
        error: state.admDataManagement.error,
        success: state.admDataManagement.success,
        result: state.admDataManagement.result,
        dbCurrentUsage: state.admDataManagement.dbCurrentUsage,
    }))

    useEffect(() => {
        dispatch(getRemainingInfoList({}))
        dispatch(getMadridCrawlInfoList({}))
        dispatch(getHagueCrawlInfoList({}))
        dispatch(getPctCrawlInfoList({}))
        dispatch(getDbCapacityInfoList({}))
        dispatch(getBackupInfoList({}))
        dispatch(getMadridPdfErrorInfoList({}))
        dispatch(getMadridDiscrepencyInfoList({}))
        dispatch(getServersInfoList({}))
        dispatch(getEmailServerInfoList({}))
    }, [])

    return (
        <React.Fragment>
            <Form onSubmit={() => { }}>
                <div className="page-content">
                    <div className="container-fluid">
                        <Nav tabs className="col-md-12 nav-tabs-custom">
                            {
                                tabItems.map(item => {
                                    return (
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer", marginInline: "5px" }}
                                                className={classnames({
                                                    active: activeTab === item,
                                                })}
                                                onClick={() => {
                                                    toggleActiveTab(item)
                                                }}
                                            >
                                                <span>
                                                    {item} &nbsp;&nbsp;
                                                    {
                                                        item == DB && dbCurrentUsage && dbCurrentUsage != "" ? 
                                                            <>{dbCurrentUsage}</> 
                                                                : <></>
                                                    }
                                                </span>
                                            </NavLink>
                                        </NavItem>
                                    )
                                })
                            }
                        </Nav>
                        <TabContent
                            activeTab={activeTab}
                            className="text-muted"
                        >
                            <MadridCrawlInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={MADRID}
                            />
                            <HagueCrawlInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={HAGUE}
                            />
                            <PctCrawlInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={PCT}
                            />
                            <MadridPdfErrorInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={MADRID_PDF_ERROR}
                            />
                            <ServersCheckInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={SERVERS}
                            />
                            <EmailServerStatusInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={EMAIL_SERVER}
                            />
                            <DbCapacityInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={DB}
                            />
                            <BackupInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={BACKUP}
                            />
                            <MadridDiscrepencyInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={DISCREPENCY}
                            />
                            <RomarianDbInfo
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={ROMARIAN}
                            />
                        </TabContent>

                        {
                            loading ?
                                <LoadingModal
                                    loading={loading}
                                    setLoading={() => {
                                        dispatch(setAdmDataManagementLoading(!loading));
                                    }}
                                ></LoadingModal>
                                : null
                        }

                        {
                            success ?
                                <SweetAlert
                                    title={success}
                                    timeout={2000}
                                    showCloseButton={false}
                                    showConfirm={false}
                                    success
                                    onConfirm={() => {
                                        dispatch(setAdmDataManagementSuccess(""));
                                    }}
                                ></SweetAlert>
                                : null
                        }

                        {
                            error ?
                                <SweetAlert
                                    warning
                                    title={error}
                                    onConfirm={() => {
                                        dispatch(setAdmDataManagementError(""));
                                    }}
                                ></SweetAlert>
                                : null
                        }
                    </div>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default AdmDataManagement;